export default function parseScheduleLabel(type) {
  //used to parse schedule value to label value
  switch (type) {
    case "mid":
      return "Mid- & 2 weeks before end-lease (50-50 amount)";
    case "end":
      return "4 weeks before end-lease";
    default:
      return "";
  }
}
